import React from "react"
import { StyledPaper } from "../../../../components/StyledSingleParseObjectComponents"
import { Stack, Box, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { useSelector } from "react-redux"
import { getProductTypeOptionsSelector } from "../../../../reducers/ProductTypes/productTypes"
import GenericEditIcon from "../../../../components/GenericEditIcon"
import { getDistributionCenterProductTypes } from "../../../../utils/distributionCenter"
import { COLORS } from "../../../../utils"

const useStyles = makeStyles(() => ({
  paper: {
    padding: "48px 56px"
  },
  headerTitle: {
    color: COLORS.LABEL_GREY,
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "11px"
  },
  tableHeader: {
    display: "grid",
    gridTemplateColumns: "240px repeat(4, 1fr)",
    gap: 32,
    marginBottom: "12px"
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "240px repeat(4, 1fr)",
    gap: 32,
    alignItems: "start"
  },
  label: {
    fontSize: "16px",
    color: COLORS.BLUE_PAPER_SELECTED
  },
  value: {
    fontSize: "16px",
    color: COLORS.BLACK800
  }
}))

const DistributionCentersProductTypeSettings = ({ attachRates = [], dispatch = [], onEdit = null }) => {

  const headers = ["Type de produit", "Taux de rattachement", "Pourcentage réutilisable", "Minimum", "Maximum"]
  const productTypesOptions = useSelector(getProductTypeOptionsSelector)

  const classes = useStyles()

  return (
    <StyledPaper className={classes.paper}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={5}>
        <Typography className={classes.headerTitle}>
          Paramétrage des types de produit
        </Typography>
        <GenericEditIcon onEdit={onEdit} />
      </Stack>

      {/* Table headers */}
      <Box  className={classes.tableHeader}>
        {headers.map((header, index) => (
          <Typography 
            key={index} 
            className={classes.value}
            fontWeight={500}
            lineHeight="24px"
          >
            {header}
          </Typography>
        ))}
      </Box>

      {/* Table rows */}
      <Stack spacing="12px">
        {getDistributionCenterProductTypes(productTypesOptions, ["ALL"]).map(({ label, value }, index) => {
          const displayRate = attachRates[value] != null ? `${attachRates[value]} %` : "-"
          const reusableRate =
            dispatch[value]?.reusable === null || dispatch[value]?.reusable === 0 || dispatch[value] === undefined
              ? "-"
              : `${dispatch[value].reusable} %`
          const min = dispatch[value]?.min != null ? dispatch[value].min : "-"
          const max = dispatch[value]?.max != null ? dispatch[value].max : "-"

          return (
            <Box
              key={index} className={classes.tableRow}>
              <Typography className={classes.label}>{label}</Typography>
              <Typography className={classes.value}>{label === "Plat" ? "-" : displayRate}</Typography>
              <Typography className={classes.value}>{reusableRate}</Typography>
              <Typography className={classes.value}>{min}</Typography>
              <Typography className={classes.value}>{max}</Typography>
            </Box>
          )
        })}
      </Stack>
    </StyledPaper>
  )
}

export default DistributionCentersProductTypeSettings